import {Slot, Text, Trail, Typography} from '@yandex-delivery/blocks'
import {CarBodyImage} from '@yandex-delivery/form'

import {Body, Counter, Tabs} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import * as classes from './CargoRequirements.classes'
import {useVerticalCargoRequirements} from './hooks'
import {getFallbackValue} from './utils/get-fallback-value'

export function CargoRequirements() {
  const {cargoTypeFieldName, selectedOption, minCargoLoaders, maxCargoLoaders, preparedCarBodyOptions} =
    useVerticalCargoRequirements()

  return (
    <Body
      tail={
        <>
          <Slot className={classes.slot} mb="xs">
            <Text>
              <Typography thickness="regular" variant="body2">
                {selectedOption?.title}
              </Typography>
              <Typography color="minor" thickness="regular" variant="caption1">
                {selectedOption?.text}
              </Typography>
            </Text>
            <Trail className={classes.cargoType} mr="m">
              <Tabs
                items={preparedCarBodyOptions}
                name="offerFlow.vertical.requirements.cargo_type.selectedValue"
                size="m"
              />
            </Trail>
          </Slot>
          <div />
          <Slot className={classes.slot} mb="xs" size="l">
            <Text>
              <Typography thickness="regular" variant="body2">
                {i18n('cargo-count.title', 'Грузчики')}
              </Typography>
              <Typography color="minor" thickness="regular" variant="caption1">
                {i18n('cargo-count.description', 'Помогут донести вещи от двери до двери')}
              </Typography>
            </Text>
            <Trail mr="m">
              <Counter
                classes={classes.counterClasses}
                defaultValue={minCargoLoaders}
                max={maxCargoLoaders}
                min={minCargoLoaders}
                name="offerFlow.vertical.requirements.cargo_loaders.selectedValue"
                size="m"
              />
            </Trail>
          </Slot>
        </>
      }
    >
      <CarBodyImage getFallbackValue={getFallbackValue} name={cargoTypeFieldName} />
    </Body>
  )
}
